import React from 'react';
import PersonnelTable from '../components/PersonnelTable';
import PayrollTable from '../components/PayrollTable';
import ExpenseTable from '../components/ExpenseTable';
import RipplingPayrollTable from '../components/RipplingPayrollTable';
import DepositTable from '../components/DepositTable';
import CreditCardExpense from '../components/CreditCardExpense';

const Payroll = () => {
  return (
    <div>
      <h1>Payroll Transactions</h1>
      <PayrollTable />
      {/* <h1>Debit Card Transactions</h1>
      <ExpenseTable />  
      <h1>Credit Card Transactions</h1>
      <CreditCardExpense />   */}

    </div>
  );
};

export default Payroll;
